export default "https://cdn.questicon.mathletics.com/assets/images/icon_tick-ecf92c5ba92b11ac0a0283aae0e31053.svg";